export const SETTINGS_ROUTES = {
  ROOT: '',
  RELEASE_NOTES: 'release-notes',
  REQUESTS: 'requests',
  STATUS: 'status',
  RESEARCHERS: 'researchers',
  PARTICIPANTS: 'participants',
};
